export function determineLanguageCode(url){
  if(url.includes('fr.ford.ca') || url.includes('frqa2.ford.ca') || url.includes('frqa.ford.ca') || url.includes('localhost:3007') ){
    return 'FR';
  }
  return 'EN';
}